<!-- ✅ Top Toolbar -->
<mat-toolbar *ngIf="showLayout" color="primary" class="topbar">
    <div class="toolbar-left">
        <!-- Always show menu button -->
        <button mat-icon-button (click)="toggleSidenav()" class="menu-button">
      <mat-icon>menu</mat-icon>
    </button>
        <span class="app-title">Lead Management System</span>
    </div>

    <div class="toolbar-right">
        <!-- Notifications -->
        <button mat-icon-button matTooltip="New Leads" [matMenuTriggerFor]="newLeads" *ngIf="userType=='Admin' || userType=='Counsellor'">
        <mat-icon [ngStyle]="{'color':'#27682'}">notifications</mat-icon>
        <span class="position-absolute top-20 start-150  
                translate-middle p-1 rounded-pill  
                bg-danger border border-light  
                rounded-circle badge" style="margin-top: 8px;">{{cntNewLeads}}</span>
    </button>
        <mat-menu #newLeads [overlapTrigger]="false" yPosition="below">
            <form (click)="stopPropagation($event)">
                <table class="table-striped">
                    <tr>

                        <td colspan="2">
                            <h6 class="dropdown-header text-center" style="background-color: rgb(14, 96, 155);margin-top: -10px;color: white;">
                                New Leads
                            </h6>
                        </td>
                    </tr>
                    <tbody style="overflow-y: scroll;display:block;
                height:300px;">
                        <tr style="font-size: small; padding-left: 10px;padding-right: 3px;line-height: 1.5;margin: 0px; font-family: 'Courier New', Courier, monospace; word-wrap: break-word; white-space: -moz-pre-wrap; white-space: pre-wrap;" *ngFor="let item of newLeadsTillToday">
                            <td *ngIf="item.display" style="padding-left:5px ;">A New Student {{item.studentName}} from {{item.source}} added to your list on {{item.onDate}}

                            </td>
                            <td *ngIf="item.display" style="cursor: pointer;">
                                <mat-icon (click)="clearLeadClick(item.refNo)">clear</mat-icon>
                            </td>
                        </tr>
                    </tbody>
                    <tr>
                        <td colspan="2">
                            <a class="dropdown-item text-center small " style="padding-bottom: -10px;background-color: rgb(5, 60, 110);color: white;" href="/leads">Show All New Leads</a>
                        </td>
                    </tr>
                </table>




            </form>
        </mat-menu>
        <button mat-icon-button matTooltip="Upcoming Leads" [matMenuTriggerFor]="upcoingFollowups" *ngIf="userType=='Admin' || userType=='Counsellor'">
        <mat-icon>notifications_active</mat-icon>
        <span class="position-absolute top-20 start-150  
                translate-middle p-1 rounded-pill  
                bg-danger border border-light  
                rounded-circle badge" style="margin-top: 8px;">{{cntFolloUps}}</span>
    </button>
        <mat-menu #upcoingFollowups [overlapTrigger]="false" yPosition="below">

            <form (click)="stopPropagation($event)">
                <table class="table-striped">
                    <tr>
                        <td colspan="2">
                            <h6 class="dropdown-header text-center" style="background-color: rgb(14, 96, 155);margin-top: -10px;color: white;">
                                Follow-Ups
                            </h6>
                        </td>
                    </tr>
                    <tbody style="overflow-y: scroll;display:block;
                height:300px;">
                        <tr style="font-size: small; padding-left: 10px;padding-right: 3px;line-height: 1.5;margin: 0px; font-family: 'Courier New', Courier, monospace; word-wrap: break-word; white-space: -moz-pre-wrap; white-space: pre-wrap;" *ngFor="let item of followUpList">
                            <td *ngIf="item.display" style="padding-left:5px ;">
                                Follow-Ups scheduled on {{item.onDate}} at {{item.scheduleTime}} for {{item.studentName}}. Last note was '{{item.note}}'

                            </td>
                            <td *ngIf="item.display" style="cursor: pointer;">
                                <mat-icon (click)="clearFollowUpClick(item.refNo)">clear</mat-icon>
                            </td>
                        </tr>
                    </tbody>
                    <tr>
                        <td colspan="2">
                            <a class="dropdown-item text-center small " style="padding-bottom: -10px;background-color: rgb(5, 60, 110);color: white;" href="/upcoming-follow-ups">Show All Follow-Ups</a>
                        </td>
                    </tr>
                </table>




            </form>







        </mat-menu>




        <button mat-icon-button matTooltip="My Account" [matMenuTriggerFor]="userAccountMenu" style="padding-right: 5px;">
        <mat-icon>account_circle</mat-icon>
    </button>
        <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
            <button mat-menu-item (click)="Profile();">
            <mat-icon>person</mat-icon><span>My Profile</span>
        </button>
            <button mat-menu-item (click)="settingsClick()">
            <mat-icon>settings</mat-icon><span>Settings</span>
        </button>
            <button mat-menu-item (click)="activityLog()">
            <mat-icon>help</mat-icon><span>Activity Log</span>
        </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="logOutClick()">
            <mat-icon>exit_to_app</mat-icon>Logout
        </button>
        </mat-menu>


    </div>
</mat-toolbar>

<!-- ✅ Main Layout -->
<mat-sidenav-container *ngIf="showLayout" class="layout-container">
    <!-- Sidebar (always mobile style) -->
    <mat-sidenav #sidenav mode="over" [opened]="false" class="sidebar" (closedStart)="mobileMenuOpen = false">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 10px; border-bottom: 1px solid #e0e0e0;">
            <span style="font-weight: 600; font-size: 11px;">Menu</span>
            <button mat-icon-button (click)="closeSidenav()" style="margin: 0; padding: 0; width: 32px; height: 32px; font-size: 18px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px;">close</mat-icon>
            </button>
        </div>
        <mat-nav-list>

            <ng-container *ngFor="let item of menuItems">
                <!-- Single menu item -->

                <a *ngIf="!item.submenu" mat-list-item [routerLink]="item.route" routerLinkActive="active" (click)="closeOnMobile()">
                    <mat-icon matListIcon>{{ item.icon }}</mat-icon>
                    <span matLine>{{ item.title }}</span>
                </a>

                <!-- Menu with submenu -->
                <div *ngIf="item.submenu" class="submenu">
                    <div class="submenu-header" (click)="toggleSubMenu(item.title)">
                        <mat-icon>{{ item.icon }}</mat-icon>
                        <span>{{ item.title }}</span>
                        <mat-icon class="expand-icon">
                            {{ expanded[item.title] ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                    </div>

                    <mat-nav-list *ngIf="expanded[item.title]">
                        <a *ngFor="let sub of item.submenu" mat-list-item [routerLink]="sub.route" routerLinkActive="active" (click)="closeOnMobile()">
                            <mat-icon matListIcon>{{ sub.icon }}</mat-icon>
                            <span matLine>{{ sub.title }}</span>
                        </a>
                    </mat-nav-list>
                </div>
            </ng-container>
        </mat-nav-list>
    </mat-sidenav>

    <!-- ✅ Main Content Area -->
    <mat-sidenav-content>
        <div class="content">
            <router-outlet></router-outlet>
        </div>

        <!-- ✅ Fixed Footer -->
        <footer class="footer">
            © 2025 Lead Management System
        </footer>
    </mat-sidenav-content>
</mat-sidenav-container>

<!-- ✅ Login Page -->
<div *ngIf="!showLayout" class="login-wrapper">
    <app-idle-warning [seconds]="countdown"></app-idle-warning>
    <router-outlet></router-outlet>
</div>